module.exports = __webpack_public_path__ + "static/media/spinner.ab497855.gif";